import React, { useContext, useEffect, useState, useRef, useMemo, useCallback } from 'react';
import { DatabaseContext } from '../../../redux/DatabaseStore';
import { LocaleContext } from '../../../components/LocaleContext';
import { defaultProductLogoSrc } from '../../../constants/brandingDisplay';
import { buildCanonicalPrintFooterHtml, buildCanonicalPrintHeaderHtml } from '../../../utils/printChrome';
import { useFormik } from 'formik';
import { getRequest, postRequest, deleteRequest, tabulatorGet } from '../../../api/ApiController';
import { AddIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, EditRowIcon, DeleteIcon, EditIcon, PaperClipIcon, ActivateIcon, DeactivateIcon, RefreshIcon } from "../../svg/svgIcons";
import { Dialog } from 'primereact/dialog';
import { InfinitySpin } from 'react-loader-spinner';
import { confirmDialog } from 'primereact/confirmdialog';
import AuthContext from '../../../components/AuthContext';
import { Splitter, SplitterPanel } from 'primereact/splitter';
import { ReactTabulator,reactFormatter } from 'react-tabulator';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css"
import '../../../assets/css/style.css';
import '../../../assets/css/iconsmenu.css'
import UtilContext from '../../../components/UtilContext';
import { PanelMenu } from 'primereact/panelmenu';
import { Checkbox } from 'primereact/checkbox';
import { OverflowMenuProvider } from '../../../components/toolbar/OverflowMenu';
import IntersectionObserverWrapper from '../../../components/toolbar/IntersectionObserverWrap';
import { MultiSelect } from 'primereact/multiselect';
import { Dropdown } from 'primereact/dropdown';
import { resetTabulatorMask } from '../../../utils/tabulatorResetMask';
import { extractSafePaginationParams, cleanSorters, createDedupedAjaxRequest, refreshProgressiveFromStart, safeParse } from '../../../utils/tabulatorProgressiveLoading';
import { getPusherChannel } from '../../../utils/pusherChannel';
export default function TrainingCompanyContactAdd({training_company, type}) {

    const [state,dispatch] = useContext(DatabaseContext);
    const { t } = useContext(LocaleContext);
    const {setDialogText,setVisible,openFavoriteDialog,toast,setFastView,setUserMaskFilter, openChosenNotificationPreferences} = useContext(UtilContext);
    const {user} = useContext(AuthContext);

    const [closeTab,setCloseTab] = useState(false);
    const ref = useRef(null);
    const submitRef = useRef(null);
    const overlayRef = useRef(null);
    const inFlightRef = useRef({ sig: null, promise: null });
    const completedCacheRef = useRef(new Map());
    const savedHScrollRef = useRef({ left: 0, pending: false });

    const [trainingDepartment,setTrainingDepartment] = useState([]);
    const [trainings,setTrainings] = useState([]);

    const [markUnmark, setMarkUnmarked] = useState(true);

    const [columnsVisible, setColumnsVisible] = useState({name:true,tel_number:true,email:true,description:true,'lecturer.name':true,'machine.name':true});
    const [maskVisible, setMaskVisible] = useState(false);
const [formCompany,setFormCompany] = useState(training_company);
    const [formType, setFormType] = useState(type);
    const [trainingCardsList, setTrainingCardsList] = useState([]);
    const [lecturersFallback, setLecturersFallback] = useState([]);
    const effectiveLecturers = (state.lecturers || []).length ? (state.lecturers || []) : lecturersFallback;

    // Načítanie firiem (pre formulár + kontakty tabuľky) pri otvorení – ako v trng033 jeden zdroj dát
    useEffect(() => {
        getRequest("/api/companies").then((r) => {
            if (r?.data != null) dispatch({ type: 'load_companies', newCompanies: r.data });
        }).catch(() => {});
    }, [dispatch]);

    useEffect(() => {
        getRequest("/api/training_cards")
            .then((r) => setTrainingCardsList(r?.data ?? r ?? []))
            .catch(() => {});
    }, []);

    useEffect(() => {
        if ((state.lecturers || []).length > 0) return;
        getRequest("/api/lecturers").then((r) => { const list = r?.data ?? r ?? []; setLecturersFallback(Array.isArray(list) ? list : []); }).catch(() => {});
    }, [state.lecturers?.length]);

    //TODO dorobit contractor id
    const [insertCopyIcon,setInsertCopyIcon] = useState((user.permissions?.includes("add training-company"))?false:true);
    const [scrollIcons,setScrollIcons] = useState((user.permissions?.includes("edit training-company"))?false:true);
    const [visibleLoading,setVisibleLoading] = useState(false);
    const [visibleCard,setVisibleCard] = useState(false);
    const [editIcon,setEditIcon] = useState(true);
    const [deleteIcon,setDeleteIcon] = useState(true);
    const [copyIcon,setCopyIcon] = useState(true);

    const [selectedCard,setSelectedCard] = useState(null);

    const [showTemplateRecordAdd, setShowTemplateRecordAdd] = useState(false);
    const [showIntervalCalibration, setShowIntervalCalibration] = useState(false);
    const [visibleFiles,setVisibleFiles] = useState(false);
    const [images,setImages] = useState('');
    const [templates,setTemplates] = useState('');
    const [viewedImage,setViewedImage] = useState('');

    const [fileList, setFileList] = useState([]);
    const fileListRef = useRef(null);

    const [updatefileList, setUpdateFileList] = useState([]);
    const updateFileListRef = useRef(null);

    function addNewTrainingCard(){
        setTrainingDepartment([]);
        setTrainings([]);
        setSelectedCard(null);
        setShowTemplateRecordAdd(true);
    }

    function editNewTrainingCard(){
        const selected = getTable()?.getSelectedData?.() ?? [];
        if (selected.length) { formikUpdate.setValues(selected[0]); setVisibleCard(true); }
    }

    function hideEditCard(){
        formikUpdate.resetForm();
        setVisibleCard(false);
    }

    const onSelectRow = () => {
        setEditIcon(true);
        setCopyIcon(true);
        setDeleteIcon(true);
        const selected = getTable()?.getSelectedData?.() ?? [];
        if (selected.length === 1) {
            if (user.permissions?.includes("edit training-company")) setEditIcon(false);
            if (user.permissions?.includes("delete training-company")) setDeleteIcon(false);
            if (user.permissions?.includes("add training-company")) setCopyIcon(false);
            setSelectedCard(selected[0]);
        }
    }

    const pageSizePc = useMemo(() => {
        const v = (state.module_settings || []).find(s => s.module === 'global' && s.key === 'page_size_pc')?.value;
        const n = parseInt(v, 10);
        return (Number.isFinite(n) && n > 0) ? n : 50;
    }, [state.module_settings]);

    const getTable = useCallback(() => ref.current?.table ?? ref.current, []);
    const captureHScroll = useCallback(() => {
        const table = getTable();
        if (!table) return;
        const holder = table.rowManager?.element;
        if (!holder) return;
        savedHScrollRef.current = { left: holder.scrollLeft, pending: true };
    }, [getTable]);
    const restoreHScroll = useCallback(() => {
        if (!savedHScrollRef.current.pending) return;
        const table = getTable();
        if (!table) return;
        const holder = table.rowManager?.element;
        const header = table.columnManager?.contentsElement;
        if (!holder) return;
        const left = savedHScrollRef.current.left;
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                holder.scrollLeft = left;
                if (header) header.scrollLeft = left;
                savedHScrollRef.current.pending = false;
            });
        });
    }, [getTable]);
    const refreshFromStart = useCallback(() => refreshProgressiveFromStart(getTable, completedCacheRef, t('Common.LoadingEllipsis')), [getTable]);

    const currentCompanyId = formCompany?.id ?? null;
    useEffect(() => {
        const channel = getPusherChannel();
        if (!channel || currentCompanyId == null) return;
        const DEDUPE_MS = 800;
        const lastHandled = { key: '', at: 0 };
        const shouldSkip = (eventType, id) => {
            if (id == null) return true;
            const key = `${eventType}-${id}`;
            const now = Date.now();
            if (lastHandled.key === key && now - lastHandled.at < DEDUPE_MS) return true;
            lastHandled.key = key;
            lastHandled.at = now;
            return false;
        };
        const onCreated = (data) => {
            const id = data?.id ?? null;
            if (id == null || shouldSkip('company_contact.created', id)) return;
            getRequest(`/api/company_contacts/${id}`).then((res) => {
                const rowData = res?.data?.data ?? res?.data ?? res;
                if (!rowData?.id || rowData.company_id !== currentCompanyId) return;
                const table = getTable();
                const row = table?.getRow?.(rowData.id);
                if (row) row.update(rowData);
                else table?.addData?.([rowData], true);
            }).catch(() => {});
        };
        const onUpdated = (data) => {
            const id = data?.id ?? null;
            if (id == null || shouldSkip('company_contact.updated', id)) return;
            getRequest(`/api/company_contacts/${id}`).then((res) => {
                const rowData = res?.data?.data ?? res?.data ?? res;
                if (!rowData?.id) return;
                const table = getTable();
                const row = table?.getRow?.(rowData.id) ?? table?.getRows?.().find((r) => r.getData().id === id);
                if (rowData.company_id === currentCompanyId) {
                    if (row) row.update(rowData);
                    else table?.addData?.([rowData], true);
                } else if (row) row.delete();
            }).catch(() => {});
        };
        const onDeleted = (data) => {
            const id = data?.id ?? null;
            if (id == null || shouldSkip('company_contact.deleted', id)) return;
            const table = getTable();
            const row = table?.getRow?.(id) ?? table?.getRows?.().find((r) => r.getData().id === id);
            if (row) row.delete();
        };
        channel.bind('company_contact.created', onCreated);
        channel.bind('company_contact.updated', onUpdated);
        channel.bind('company_contact.deleted', onDeleted);
        return () => {
            channel.unbind('company_contact.created', onCreated);
            channel.unbind('company_contact.updated', onUpdated);
            channel.unbind('company_contact.deleted', onDeleted);
        };
    }, [getTable, currentCompanyId]);

    const buildRequestParams = useCallback((paramsFromTabulator = {}) => {
        const extra = {
            module: 'training',
            company_id: formCompany?.id ?? '',
            ...extractSafePaginationParams(paramsFromTabulator),
        };
        if (extra.size === undefined || extra.size === null) extra.size = pageSizePc;
        const t = getTable();
        const hf = t?.getHeaderFilters?.() ?? [];
        hf.forEach(f => {
            if (f?.field == null || f.value == null || String(f.value).trim() === '') return;
            const field = f.field === 'lecturer.name' ? 'lecturer_name' : f.field === 'machine.name' ? 'machine_name' : f.field;
            extra['filter_' + field] = String(f.value).trim();
        });
        const sorters = cleanSorters(paramsFromTabulator?.sorters ?? t?.getSorters?.() ?? []);
        if (sorters?.length) extra.sorters = JSON.stringify(sorters);
        return extra;
    }, [formCompany?.id, pageSizePc, getTable]);

    const baseAjaxRequest = useMemo(
        () => createDedupedAjaxRequest(buildRequestParams, tabulatorGet, inFlightRef, completedCacheRef),
        [buildRequestParams]
    );
    const ajaxRequestFunc = useCallback((url, config, params) => baseAjaxRequest(url, config, params), [baseAjaxRequest]);

    const refreshContacts = useCallback(() => {
        captureHScroll();
        refreshFromStart();
    }, [captureHScroll, refreshFromStart]);

    const validate = values => {
        const errors = {};
        if (values?.machines?.length<1) {
            errors.machines = t('Common.RequiredField');
        }
        /*if (!values.type) {
            errors.type = t('Common.RequiredField');
        }*/
        return errors;
    };

    const formik = useFormik({
        initialValues:{
            module:'training',employee_option:false,employee_id:'',name:'',tel_number:'',email:'',description:'',lecturer_id:'',machines:[]
        },
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            let formData = new FormData();
            for (let value in values) {
                if(value=="employee_id"){
                    formData.append("employee_id", values.employee_id?.id ? values.employee_id?.id : "");
                }
                else if(value=="machines"){
                    formData.append("machines", values.machines.map(machine => machine.id));
                }
                else formData.append(value, values[value] != null ? values[value] : "");
            }
            formData.append("company_id",formCompany.id);
            postRequest('/api/company_contacts', formData,true)
            .then((response) => {
                if(closeTab) dispatch({type:'close_tab',id:state.selectedTab});
                formik.resetForm();
                getTable()?.replaceData?.();
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                setShowTemplateRecordAdd(false);
            }).catch((reason) => {
                if(!navigator.online){
                    alert(t('ServiceTask.OfflineQueuedAlert'));
                }
                else{
                    alert(t('Common.Toast.ActionFailedDetail'));
                }
            });
        },
    });

    const formikUpdate = useFormik({
        initialValues: selectedCard == null ? {
             module:'training',employee_option:false,employee_id:'',name:'',tel_number:'',email:'',description:'',lecturer_id:'',machines:[]
        } : {
            id:selectedCard?.id, module:selectedCard?.module,employee_option:selectedCard?.employee_id ? true : false,employee_id:selectedCard?.employee_id ? state.employees?.filter(employee => employee.id == selectedCard?.employee_id)?.map(employee => ({name:employee?.name,id:employee?.id}))[0] : '',
            name:selectedCard?.employee_id ? selectedCard?.employee?.name : selectedCard?.name,
            tel_number:selectedCard?.employee_id ? selectedCard?.employee?.tel_number : selectedCard?.tel_number,
            email:selectedCard?.employee_id ? selectedCard?.employee?.email : selectedCard?.email,
            description:selectedCard?.description,lecturer_id:selectedCard?.lecturer_id,
            machines:selectedCard.machines ? selectedCard.machines.map((machine) => ({name:machine?.name,id:machine?.id})) : [],
        },
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            let formData = new FormData();
            for (let value in values) {
                if(value=="employee_id"){
                    formData.append("employee_id", values.employee_id?.id ? values.employee_id?.id : "");
                }
                else if(value=="machines"){
                    formData.append("machines", values.machines.map(machine => machine.id));
                }
                else formData.append(value, values[value] != null ? values[value] : "");
            }
            formData.append("company_id",formCompany.id);
            postRequest(`/api/company_contacts/update/${formikUpdate.values.id}`, formData,true)
            .then((response) => {
                getTable()?.replaceData?.();
                if(closeTab) dispatch({type:'close_tab',id:state.selectedTab});
                setVisibleCard(false);
                formikUpdate.resetForm();
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
            }).catch((reason) => {
                if(!navigator.online){
                    alert(t('ServiceTask.OfflineQueuedAlert'));
                }
                else{
                    alert(t('Common.Toast.ActionFailedDetail'));
                }
            });
        },
    });

    function getIndex(employee_id) {
        return (trainingCardsList || []).findIndex(obj => obj.id === employee_id);
    }

    async function scrollToFirst(){
        /*let my_training_card = state.training_cards[0];
        setFormGaugeCalibration(my_training_card);*/
    }
    
    async function scrollUp(){
        /*let id = getIndex(formik.values.id);
        if(id-1>=0){
            setFormGaugeCalibration(trainingCardsList[id-1]);
        }*/
    }
    
    async function scrollDown(){
        /*let id = getIndex(formik.values.id);
        if(id+1<(trainingCardsList || []).length){
            setFormGaugeCalibration(trainingCardsList[id+1]);
        }*/
    }
    
    async function scrollToLast(){
        /*let last = state.training_cards.length-1;
        let my_training_card = state.training_cards[last];
        setFormGaugeCalibration(my_training_card);*/
    }

      function onEditRow(template_record){
        formikUpdate.setValues(template_record);
        setSelectedCard(template_record);
        setVisibleCard(true);
      };
      
      function EditRowFormatter(props) {
        const rowData = props.cell.getRow().getData();
        return <div className='flex items-center justify-center w-full h-full'><button type='button' onClick={() => onEditRow(rowData)}><EditRowIcon/></button></div>;
      }

    const reject = () => {
        toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.RequestCancelled'), life: 3000 });
    }

    const acceptCalibration = () => {
        const rows_to_delete = getTable()?.getSelectedData?.() ?? [];
        Promise.all(rows_to_delete.map(element =>
            deleteRequest(`/api/company_contacts/${element.id}`)
                .then(() => toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordDeletedDetail') }))
                .catch(() => toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.DeleteFailedDetail'), life: 3000 }))
        )).then(() => {
            captureHScroll();
            refreshFromStart();
        });
    }

    const confirm = () => {
        confirmDialog({
            message: t('Common.ConfirmDeleteRecord'),
            header: t('Common.ConfirmDelete'),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: t('Common.No'),
            rejectLabel: t('Common.Yes'),
            accept: reject,
            reject: acceptCalibration
        });
    };
    
    function NameFormatter(props) {
        const rowData = props.cell.getRow().getData();
        if(rowData?.employee_id){
            return rowData?.employee?.name;
        }
        else{
            return rowData?.name;
        }
    }

    function TelNumberFormatter(props) {
        const rowData = props.cell.getRow().getData();
        console.log(rowData);
        if(rowData?.employee_id){
            return rowData?.employee?.tel_number;
        }
        else{
            return rowData?.tel_number;
        }
    }

    function EmailFormatter(props) {
        const rowData = props.cell.getRow().getData();
        console.log(rowData);
        if(rowData?.employee_id){
            return rowData?.employee?.email;
        }
        else{
            return rowData?.email;
        }
    }

    function machineHeaderFilter(headerValue, rowValue, rowData, filterParams){
        if(rowData.machines?.length<0)return false;
        else return rowData.machines.map(machine => machine?.name).join('/').toLowerCase().includes(headerValue.toLowerCase());
    }

    function MachineFormatter(props) {
        const rowData = props.cell.getRow().getData();
        return rowData.machines.map((item) => item.name).join('/');
    }

    const [columns,setColumns] = useState([
        { formatter:"rowSelection", titleFormatter:"rowSelection", hozAlign:"center", width: 44, minWidth: 44, headerSort: false, resizable: false },
        { hozAlign:"center", width: 44, minWidth: 44, headerSort: false, formatter: reactFormatter(<EditRowFormatter/>), resizable: false },
        { title: 'Meno', field: 'name',headerFilter:"input",minWidth: 200,widthGrow:2,resizable:false,formatter: reactFormatter(<NameFormatter/>)},
        { title: t('Common.Column.Phone'), field: 'tel_number',headerFilter:"input",minWidth: 200,widthGrow:2,resizable:false,formatter: reactFormatter(<TelNumberFormatter/>)},
        { title: 'Email', field: 'email',minWidth: 200,widthGrow:2,headerFilter:"input",resizable:false,formatter: reactFormatter(<EmailFormatter/>)},
        { title: t('Common.Description'), field: 'description',minWidth: 200,widthGrow:2,headerFilter:"input",resizable:false},
        { title: 'Lektor', field: 'lecturer.name',minWidth: 200,widthGrow:2,headerFilter:"input",resizable:false},
        { title: 'Stroj', field: 'machine.name',minWidth: 200,widthGrow:2,headerFilter:"input",resizable:false,formatter: reactFormatter(<MachineFormatter/>),headerFilterFunc:machineHeaderFilter},
    ]);

    function setMask(item,value){
        const columnVisible = {...columnsVisible};
        columnVisible[item] = value;
        const table = getTable();
        for (const val in columnVisible) {
          if (columnVisible[val] === false) table?.hideColumn?.(val);
          else table?.showColumn?.(val);
        }
        setColumnsVisible(columnVisible);
      }

      const itemRenderer = (item, options) => (
        <a className="flex align-items-center px-3 py-2 cursor-pointer items-center bg-[#333] text-white w-[180px]" onClick={options.onClick}>
            <span className={`${item.icon} text-primary`} />
            <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
            {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
        </a>
      );
    
      const [expandedKeys, setExpandedKeys] = useState({});
    
      const handleClickOutside = (event) => {
        if (overlayRef.current && !overlayRef.current.contains(event.target)) {
            setExpandedKeys({});
        }
      };
    
      useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

    const defaultColumnsVisible = {name:true,tel_number:true,email:true,description:true,'lecturer.name':true,'machine.name':true};
    const resetMask = () => {
        resetTabulatorMask({ page: 'TrainingCompanyContactAdd', defaultColumnsVisible, ref, columns, setColumnsVisible });
        captureHScroll();
        refreshFromStart();
    };
  
      const items = [
      {
        key: '0',
        label: t('Common.Actions'),
        icon: 'pi pi-sliders-v',
        template: itemRenderer,
        items: [
            {
                key: '0_1',
                label: t('Common.SetFilter'),
                icon: 'pi pi-filter',
                command: () => { captureHScroll(); setUserMaskFilter("TrainingCompanyContactAdd", "set_filters", null, getTable()?.getHeaderFilters?.() ?? [], null); refreshFromStart(); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); },
                template: itemRenderer,
            },
              {
                key: '0_2',
                label: t('Common.ClearFilter'),
                icon: 'pi pi-filter-slash',
                command: () => { setUserMaskFilter("TrainingCompanyContactAdd", "set_filters", null, [], null); getTable()?.clearHeaderFilter?.(); captureHScroll(); refreshFromStart(); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); },
                template: itemRenderer,
            },
            {
                key: '0_3',
                label: t('Common.SetSorting'),
                icon: 'pi pi-sort-alt',
                command: () => { captureHScroll(); setUserMaskFilter("TrainingCompanyContactAdd", "set_sorters", null, null, null, getTable()?.getSorters?.() ?? []); refreshFromStart(); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); },
                template: itemRenderer,
            },
            {
                key: '0_4',
                label: t('Common.ClearSorting'),
                icon: 'pi pi-sort-alt-slash',
                command: () => { setUserMaskFilter("TrainingCompanyContactAdd", "set_sorters", null, null, null, []); getTable()?.setSort?.([]); captureHScroll(); refreshFromStart(); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); },
                template: itemRenderer,
            },
            {
                key: '0_5',
                label: t('Common.SetMask'),
                icon: 'pi pi-server',
                command: () => {setMaskVisible(true);OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
                template: itemRenderer,
            },
            {
                key: '0_5b',
                label: t('Common.ResetUserMask'),
                icon: 'pi pi-refresh',
                command: () => { resetMask(); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); },
                template: itemRenderer,
            },
            {
              key: '0_6',
              label: t('Common.Notifications'),
              icon: 'pi pi-envelope',
              command: () => {openChosenNotificationPreferences('TrainingCompanyContactAdd');OverflowMenuProvider.setVisible(null);},
              template: itemRenderer,
          },
        ]
      }
    ];
      function changeMarkings(value){
        const table = getTable();
        const columnVisible = { ...columnsVisible };
        for (const val in columnVisible) {
          if (val !== "id" && val !== "editor") {
            columnVisible[val] = !!value;
            if (value) table?.showColumn?.(val);
            else table?.hideColumn?.(val);
          }
        }
        setColumnsVisible(columnVisible);
      }

      function changeEmployee(select_employee){
        if(showTemplateRecordAdd){
            formik.setFieldValue("employee_id",select_employee);
            formik.setFieldValue("tel_number",'');
            formik.setFieldValue("email",'');
            if(select_employee?.id){
                let chosen_employee = (state.employees || []).find(employee => employee.id == select_employee.id);
                if(chosen_employee){
                    formik.setFieldValue("tel_number",chosen_employee?.tel_number ? chosen_employee?.tel_number : '');
                    formik.setFieldValue("email",chosen_employee?.email ? chosen_employee?.email : '');
                }
            }
        }
        else{
            formikUpdate.setFieldValue("employee_id",select_employee);
            formikUpdate.setFieldValue("tel_number",'');
            formikUpdate.setFieldValue("email",'');
            if(select_employee?.id){
                let chosen_employee = (state.employees || []).find(employee => employee.id == select_employee.id);
                if(chosen_employee){
                    formikUpdate.setFieldValue("tel_number",chosen_employee?.tel_number ? chosen_employee?.tel_number : '');
                    formikUpdate.setFieldValue("email",chosen_employee?.email ? chosen_employee?.email : '');
                }
            }
        }
      }


    return ( 
        <>
            <div>
            <div className='w-full h-10 flex flex-row bg-[#333]'>
            <IntersectionObserverWrapper>
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="add"><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => addNewTrainingCard()}><AddIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="edit"><button className="disabled:opacity-25" disabled={editIcon} onClick={() => editNewTrainingCard()}><EditIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="delete"><button className="disabled:opacity-25" disabled={deleteIcon} onClick={confirm}><DeleteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="refresh"><button type="button" onClick={refreshContacts} title={t('Common.Refresh')}><RefreshIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="first"><button className="disabled:opacity-25" onClick={() => scrollToFirst()} disabled={scrollIcons}><BackToFirstIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="back"><button className="disabled:opacity-25" onClick={() => scrollUp()} disabled={scrollIcons}><BackIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="forward"><button className="disabled:opacity-25" onClick={() => scrollDown()} disabled={scrollIcons}><ForwardIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="last"><button className="disabled:opacity-25" onClick={() => scrollToLast()} disabled={scrollIcons}><ForwardToLastIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="favorite"><button className="disabled:opacity-25" disabled onClick={() => openFavoriteDialog(t('TrainingCompanyContactAdd.Text.Upravit_skolitelov_skol_firmy'),"TrainingCompanyContactAdd")}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="price"><button className="disabled:opacity-25" disabled  onClick={() => setFastView("TrainingCompanyContactAdd",columnsVisible,columns)}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className="card flex justify-content-center z-[100]" data-targetid="actions" ref={overlayRef}>
            <PanelMenu model={items} expandedKeys={expandedKeys} onExpandedKeysChange={setExpandedKeys} className="w-full md:w-20rem"/>
          </div>
          </IntersectionObserverWrapper>
        </div>
        <Splitter className='h-[calc(100vh_-_177px)]' layout="vertical" pt={{ gutter: { className: 'bg-[#333] h-8' },gutterHandler: { className: 'bg-secondary ' } }}>
        <SplitterPanel className="flex align-items-center justify-content-center overflow-y-auto " minSize={20} size={50}>
        <div className="w-full relative flex flex-col overflow-x">
          <div className='xl:grid grid-cols-2 gap-1 mb-2'>
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                <h1 className="text-3xl font-semibold text-left text-zinc-900">{t('Ui.R67.SKOLITELIA_SKOLIACEJ_FIRMY')}</h1>
                <label className="block text-md font-semibold text-gray-800">Por.č.: {formCompany.id}</label>
                        <div>
                        <label
                            htmlFor="name"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.NAZOV_firmy')}</label>
                        <input
                            name='name'
                            type="text"
                            value={formCompany.name} readOnly
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="tel_number"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.PhoneNumber')}</label>
                        <input
                            name='tel_number'
                            type="text"
                            value={formCompany.tel_number} readOnly
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                    
                      <div>
                        <label
                            htmlFor="email"
                            className="block text-md font-semibold text-gray-800"
                        >
                            E-MAIL
                        </label>
                        <input
                            name='email'
                            type="email"
                            value={formCompany.email}  readOnly
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="contact_person"
                            className="block text-md font-semibold text-gray-800 mt-2"
                        >{t('Common.ContactPersonUpper')}</label>
                        <input
                            name='contact_person'
                            type="text"
                            value={formCompany.contact_person}  readOnly
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>        
            </div>
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                    <div>
                        <label
                            htmlFor="address"
                            className="block text-md font-semibold text-gray-800"
                        >
                            ADRESA
                        </label>
                        <input
                            name='address'
                            type="text"
                            value={formCompany.address}  readOnly
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="fax"
                            className="block text-md font-semibold text-gray-800"
                        >
                             FAX
                        </label>
                        <input
                            name='fax'
                            type="text"
                            value={formCompany.fax}  readOnly
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="web_address"
                            className="block text-md font-semibold text-gray-800"
                        >
                            WEB. ADRESA
                        </label>
                        <input
                            name='web_address'
                            type="text"
                            value={formCompany.web_address}  readOnly
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="description"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.NoteUpper')}</label>
                        <textarea
                            name='description'
                            type="text"
                            value={formCompany.description}  readOnly
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        >
                        </textarea>
                        </div>  
                        <button className='hidden' type='submit' ref={submitRef}></button>    
            </div>
            </div> 
            </div>
             </SplitterPanel>
    <SplitterPanel className="flex flex-col align-items-center justify-content-center w-full overflow-y-auto" size={40} style={{minHeight: '110px'}}>
    <ReactTabulator
      key={`training-company-contacts-${formCompany?.id ?? ''}`}
      data={undefined}
      onRef={(r) => (ref.current = r?.current)}
      className='h-full w-full'
      columns={columns}
      events={{
        rowSelectionChanged: onSelectRow,
        tableBuilt: () => {
            const table = getTable();
            if (!table) return;
            const mask = (state.user_mask_filters || []).filter(m => m.page === "TrainingCompanyContactAdd");
            if (mask.length > 0) {
                const attributes = safeParse(mask[0].attributes, []);
                const filters = safeParse(mask[0].filters, []);
                const sorters = safeParse(mask[0].sorters, []);
                const json_columns = safeParse(mask[0].columns, {});
                if (Array.isArray(attributes) && attributes.length > 1) table.setColumnLayout(attributes);
                if (Array.isArray(filters)) filters.forEach(f => table.setHeaderFilterValue(f.field, f.value));
                if (Array.isArray(sorters) && sorters.length > 0) table.setSort(sorters);
                if (json_columns && typeof json_columns === "object") {
                    setColumnsVisible(json_columns);
                    for (const column in json_columns) {
                        if (json_columns[column] === false) table.hideColumn(column);
                        else table.showColumn(column);
                    }
                }
            }
            getTable()?.replaceData?.();
        },
        headerFilterChanged: () => { captureHScroll(); refreshFromStart(); },
        renderComplete: () => restoreHScroll(),
        columnMoved: () => setUserMaskFilter("TrainingCompanyContactAdd", "column_move", null, null, getTable()?.getColumnLayout?.()),
        columnResized: () => setUserMaskFilter("TrainingCompanyContactAdd", "column_resized", null, null, getTable()?.getColumnLayout?.()),
      }}
      options={{
        layout: 'fitColumns',
        renderHorizontal: "virtual",
        rowHeight: 42,
        movableColumns: true,
        resizableColumnFit: true,
        printAsHtml: true,
        printHeader: () => buildCanonicalPrintHeaderHtml({
          branding: state?.branding,
          productFallbackSrc: defaultProductLogoSrc,
          companySettingsPrint: state?.company_settings_print,
          moduleSettings: state?.module_settings,
          title: t('Print.Title.TrainingCompanyContactAdd'),
          printDateLabel: t('Print.DateLabel'),
        }),
        printFooter: () => buildCanonicalPrintFooterHtml({ companySettingsPrint: state?.company_settings_print }),
        printRowRange: "active",
        filterMode: 'remote',
        sortMode: 'remote',
        dataLoader: true,
        dataLoaderLoading: t('Common.LoadingData'),
        dataLoaderError: t('Common.LoadFailed'),
        ajaxURL: '/api/company_contacts/paged',
        progressiveLoad: 'scroll',
        progressiveLoadScrollMargin: 80,
        paginationSize: pageSizePc,
        pagination: false,
        ajaxRequestFunc,
      }}/>
    </SplitterPanel>
    </Splitter> 
    <Dialog header={t('TrainingCompanyContactAdd.Text.Upravit_skolitela')} visible={visibleCard} style={{ width: '40vw' }} onHide={() => hideEditCard()}>
        <form onSubmit={formikUpdate.handleSubmit}>
        <div className="flex align-items-center mt-1">
                <Checkbox name="employee_option" value={"employee_option"} onChange={(e) => formikUpdate.setFieldValue("employee_option",e.checked)} checked={formikUpdate.values.employee_option} className='p-button-sm p-button-text'/>
                <label htmlFor={"employee_option"} className="ml-2">{t('Ui.R67.Nastavit_zamestnanca')}</label>
            </div>
            {!formikUpdate.values.employee_option && <div>
            <label
                htmlFor="name"
                className="block text-md font-semibold text-gray-800"
            >
                Meno
            </label>
            <input
                name='name'
                type="text"
                onChange={formikUpdate.handleChange} value={formikUpdate.values.name}
                className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
            />
            </div>}
            {formikUpdate.values.employee_option && <div>
            <label
                htmlFor="employee_id"
                className="block text-md font-semibold text-gray-800"
            >
                Zamestnanec
            </label>
            <Dropdown value={formikUpdate.values.employee_id} onChange={(e) => changeEmployee(e.value)} 
                options={(state.employees || []).filter(employee => employee?.date_of_departure=="" || employee?.date_of_departure==null).map((employee) => 
                    ({name:employee.name,id:employee.id})
                )} 
                optionLabel="name" required
                filter placeholder={t('Common.SelectEmployee')} className="w-full px-4 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
            </div>}
            <div>
            <label
                htmlFor="tel_number"
                className="block text-md font-semibold text-gray-800"
            >{t('EmployeeAdd.Label.Phone')}</label>
            <input
                name='tel_number'
                type="text"
                readOnly={formikUpdate.values.employee_option}
                onChange={formikUpdate.handleChange} value={formikUpdate.values.tel_number}
                className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
            />
            </div>
        
            <div>
            <label
                htmlFor="email"
                className="block text-md font-semibold text-gray-800"
            >
                E-mail
            </label>
            <input
                name='email'
                type="email"
                readOnly={formikUpdate.values.employee_option}
                onChange={formikUpdate.handleChange} value={formikUpdate.values.email}  
                className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
            />
            </div>  
            <div>
            <label
                htmlFor="description"
                className="block text-md font-semibold text-gray-800"
            >{t('Common.Description')}</label>
            <textarea
                name='description'
                type="text"
                onChange={formikUpdate.handleChange} value={formikUpdate.values.description}
                className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
            >
            </textarea>
            </div>  
            <div>
            <label
                htmlFor="lecturer_id"
                className="block text-md font-semibold text-gray-800"
            >
                Lektor
            </label>
            <select 
                name="lecturer_id" required
                onChange={formikUpdate.handleChange} value={formikUpdate.values.lecturer_id} 
                className="bg-white block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40">
                    <option value="">{t('Ui.R67.Vyber_lektora')}</option>
                    {effectiveLecturers?.map((lecturer) => (
                    <option key={lecturer.id} value={lecturer.id}>{lecturer.name}</option>
                ))}
            </select>
            </div>
            <div>
            <label
                htmlFor="machines"
                className="block text-md font-semibold text-gray-800"
            >
                Stroj
            </label>
            <MultiSelect value={formikUpdate.values.machines} onChange={(e) => formikUpdate.setFieldValue("machines",e.value)} 
                options={(state.machines || []).map((machine) => 
                    ({name:machine.name,id:machine.id})
                )} 
                optionLabel="name"
                dataKey="id"
                filter placeholder={t('Common.SelectMachines')} className="w-full px-4 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
            {formikUpdate.errors?.machines ? <span style={{color: "red"}}>{formikUpdate.errors?.machines}</span> : ""}     
            </div>
            <button type="submit" className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25'>{t('Common.Save')}</button>         
        </form>
    </Dialog>
        <Dialog header={t('TrainingCompanyContactAdd.Text.Pridat_skolitela')} visible={showTemplateRecordAdd} style={{ width: '40vw' }} onHide={() => setShowTemplateRecordAdd(false)}>
        <form onSubmit={formik.handleSubmit}>
            <div className="flex align-items-center mt-1">
                <Checkbox name="employee_option" value={"employee_option"} onChange={(e) => formik.setFieldValue("employee_option",e.checked)} checked={formik.values.employee_option} className='p-button-sm p-button-text'/>
                <label htmlFor={"employee_option"} className="ml-2">{t('Ui.R67.Nastavit_zamestnanca')}</label>
            </div>
            {!formik.values.employee_option && <div>
            <label
                htmlFor="name"
                className="block text-md font-semibold text-gray-800"
            >
                Meno
            </label>
            <input
                name='name'
                type="text"
                onChange={formik.handleChange} value={formik.values.name}
                className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
            />
            </div>}
            {formik.values.employee_option && <div>
            <label
                htmlFor="employee_id"
                className="block text-md font-semibold text-gray-800"
            >
                Zamestnanec
            </label>
            <Dropdown value={formik.values.employee_id} onChange={(e) => changeEmployee(e.value)} 
                options={(state.employees || []).filter(employee => employee?.date_of_departure=="" || employee?.date_of_departure==null).map((employee) => 
                    ({name:employee.name,id:employee.id})
                )} 
                optionLabel="name" required
                filter placeholder={t('Common.SelectEmployee')} className="w-full px-4 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
            </div>}
            <div>
            <label
                htmlFor="tel_number"
                className="block text-md font-semibold text-gray-800"
            >{t('EmployeeAdd.Label.Phone')}</label>
            <input
                name='tel_number'
                type="text"
                readOnly={formik.values.employee_option}
                onChange={formik.handleChange} value={formik.values.tel_number}
                className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
            />
            </div>
        
            <div>
            <label
                htmlFor="email"
                className="block text-md font-semibold text-gray-800"
            >
                E-mail
            </label>
            <input
                name='email'
                type="email"
                readOnly={formik.values.employee_option}
                onChange={formik.handleChange} value={formik.values.email}  
                className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
            />
            </div>  
            <div>
            <label
                htmlFor="description"
                className="block text-md font-semibold text-gray-800"
            >{t('Common.Description')}</label>
            <textarea
                name='description'
                type="text"
                onChange={formik.handleChange} value={formik.values.description}
                className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
            >
            </textarea>
            </div> 
            <div>
            <label
                htmlFor="lecturer_id"
                className="block text-md font-semibold text-gray-800"
            >
                Lektor
            </label>
            <select 
                name="lecturer_id" required
                onChange={formik.handleChange} value={formik.values.lecturer_id} 
                className="bg-white block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40">
                    <option value="">{t('Ui.R67.Vyber_lektora')}</option>
                    {effectiveLecturers?.map((lecturer) => (
                    <option key={lecturer.id} value={lecturer.id}>{lecturer.name}</option>
                ))}
            </select>
            </div>
            <div>
            <label
                htmlFor="lecturer_id"
                className="block text-md font-semibold text-gray-800"
            >
                Stroj
            </label>
            <MultiSelect value={formik.values.machines} onChange={(e) => formik.setFieldValue("machines",e.value)} 
                options={(state.machines || []).map((machine) => 
                    ({name:machine.name,id:machine.id})
                )} 
                optionLabel="name"
                dataKey="id"
                filter placeholder={t('Common.SelectMachines')} className="w-full px-4 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
            {formik.errors?.machines ? <span style={{color: "red"}}>{formik.errors?.machines}</span> : ""} 
            </div>   
            <button type="submit" className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25'>{t('Common.Save')}</button>         
        </form>
        </Dialog>
        <Dialog header={t('Common.SetMask')} visible={maskVisible} style={{ width: '70vw' }} onHide={() => setMaskVisible(false)}>
        <div className="flex flex-col">
        <button type="button" onClick={() => {changeMarkings(!markUnmark);setMarkUnmarked(!markUnmark);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-700 rounded-md hover:bg-zinc-500'>{markUnmark ? t('Common.DeselectAllUpper') : t('Common.SelectAllUpper')}</button>
        {columns.map(function(item, index){ 
          if(index<2) return null;
                    return <div 
                        key={index} 
                        className="flex flex-row border border-black rounded-md p-2 m-1"
                    > 

                         <Checkbox onChange={(e) => setMask(item.field,e.checked)} checked={columnsVisible[item.field]}></Checkbox><span className="ml-2">{item.title}</span>
                          
                        {/* Use the React icon component */} 
                    </div> 
                })} 
            <button onClick={() => {setUserMaskFilter("TrainingCompanyContactAdd","set_columns",columnsVisible,null,null);setMaskVisible(false);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{t('Ui.R67.SaveUpper')}</button>
        </div>
      </Dialog>
      
            </div>
            </> 
            );
} 
